import { render, staticRenderFns } from "./descriptionHavoblog.vue?vue&type=template&id=6fadcf7d&scoped=true&"
import script from "./descriptionHavoblog.vue?vue&type=script&lang=js&"
export * from "./descriptionHavoblog.vue?vue&type=script&lang=js&"
import style0 from "./descriptionHavoblog.vue?vue&type=style&index=0&id=6fadcf7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fadcf7d",
  null
  
)

export default component.exports